export default "<div class=\"loader07\"></div>";